export const strEscape = (str?: string) =>
    typeof str === 'string'
        ? str
              .replace(/>/g, '&gt;')
              .replace(/</g, '&lt;')
              .replace(/"/g, '&quot;')
              .replace(/`/g, '&#x60;')
              .replace(/'/g, '&apos;')
        : '';
